import React, { useState, useRef } from 'react';
import Modal from 'react-modal';
import { Document, Page, pdfjs } from 'react-pdf';
// PDF.js worker setup using bundled entry
// Use PDF.js worker from CDN for consistent loading
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
// Set the app element for accessibility (required by react-modal)
Modal.setAppElement('#root');

const PDFViewer = ({ url, onClose, onDelete }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1);
  const containerRef = useRef(null);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };
  const onPageLoadSuccess = pageProxy => {
    // fit to container
    const viewport = pageProxy.getViewport({ scale: 1 });
    const container = containerRef.current;
    if (container) {
      const { clientWidth, clientHeight } = container;
      const fitScale = Math.min(
        clientWidth / viewport.width,
        clientHeight / viewport.height
      );
      setScale(fitScale);
    }
  };

  return (
    <Modal
      isOpen={!!url}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={true}
      contentLabel="PDF Viewer"
      className="fixed inset-0 bg-white flex flex-col"
      overlayClassName="fixed inset-0 bg-black bg-opacity-75"
    >
      <div className="flex justify-between items-center p-2 border-b">
        <div className="flex items-center space-x-2">
          <button onClick={onClose} className="text-gray-600 hover:text-gray-800" title="Close">
            Close
          </button>
          <button
            onClick={() => window.open(url)}
            className="px-2 py-1 border rounded"
            title="Download PDF"
          >📥</button>
          <button
            onClick={() => setScale(prev => Math.max(prev - 0.2, 0.1))}
            className="px-2 py-1 border rounded"
            title="Zoom Out"
          >-</button>
          <span className="text-sm">{Math.round(scale * 100)}%</span>
          <button
            onClick={() => setScale(prev => prev + 0.2)}
            className="px-2 py-1 border rounded"
            title="Zoom In"
          >+</button>
          <button
            disabled
            className="px-2 py-1 border rounded opacity-50"
            title="Beams (Coming soon)"
          >Beams</button>
          <button
            disabled
            className="px-2 py-1 border rounded opacity-50"
            title="Columns (Coming soon)"
          >Columns</button>
        </div>
        {typeof onDelete === 'function' && (
          <button
            onClick={onDelete}
            className="text-red-600 hover:text-red-800"
            title="Delete this drawing"
          >🗑️</button>
        )}
      </div>
      <div ref={containerRef} className="flex-1 overflow-auto bg-gray-100">
        <Document
          file={url}
          onLoadSuccess={onDocumentLoadSuccess}
          loading={<div className="text-center p-4">Loading PDF...</div>}
          error={<div className="text-red-500 text-center p-4">Failed to load PDF.</div>}
        >
          <Page
            pageNumber={pageNumber}
            scale={scale}
            onLoadSuccess={onPageLoadSuccess}
          />
        </Document>
      </div>
      {numPages > 1 && (
        <div className="flex justify-center items-center p-2 border-t">
          <button
            onClick={() => setPageNumber(prev => Math.max(prev - 1, 1))}
            disabled={pageNumber <= 1}
            className="px-2 py-1 border rounded"
          >Prev</button>
          <span className="px-4">Page {pageNumber} of {numPages}</span>
          <button
            onClick={() => setPageNumber(prev => Math.min(prev + 1, numPages))}
            disabled={pageNumber >= numPages}
            className="px-2 py-1 border rounded"
          >Next</button>
        </div>
      )}
    </Modal>
  );
};

export default PDFViewer;